import script from "./WritingBoardTool.vue?vue&type=script&lang=ts&setup=true"
export * from "./WritingBoardTool.vue?vue&type=script&lang=ts&setup=true"

import "./WritingBoardTool.vue?vue&type=style&index=0&id=52a2a3a6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52a2a3a6"]])

export default __exports__